import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index:40;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 20px;
`;


export function Modal({ children, expand = false, timeout = false }) {

  const [isFinished, setIsFinished] = useState(!timeout);

  useEffect(() => {
    if (timeout) {
      setIsFinished(false);
    }
    setTimeout(() => {
      setIsFinished(true);
    }, 2000);
  }, [expand, timeout]);

  return (
    <Overlay className={`transition-opacity duration-500 z-40 ease-in-out ${(expand || !isFinished) ? 'opacity-100 pointer-events-auto ' : 'opacity-0 pointer-events-none '} `}>
      {children}
    </Overlay>
  );
}
